module.exports = {
    defaultColorPalette: 
    
 {
    "primaryPalette": {
      "backgroundColor":"#EDEEF1",
      "textColor": "#000000",
      "subTextColor": "#717274",
      "separatorColor": "#DBDBDB",
      "disabledColor": "#A9A9A9"
    },
    "secondaryPalette": {
      "backgroundColor": "#FFFFFF",
      "textColor": "#000000",
      "subTextColor": "#717274",
      "separatorColor": "#DBDBDB",
      "disabledColor": "#A9A9A9"
    },
    "sliderPalette": {
      "backgroundColor": "#000000",
      "textColor": "#FFFFFF",
      "subTextColor": "#717274",
      "separatorColor": "#DBDBDB",
      "disabledColor": "#A9A9A9"
    },
    "primaryColor":  "#E51058"
}
  
}